import _BaseController from 'Controllers/Web/_BaseController';
import ReadControllerVue from 'Vue/Web/Shop/Product/ReadController.vue';
import Splide from '@splidejs/splide';
import '@splidejs/splide/dist/css/splide.min.css';
import Datalayer from 'Controllers/Web/Datalayer';

global.Controller = new (class extends _BaseController {
    EditVue?: Vue;

    ready() {
        super.ready();

        this.EditVue = new Vue(ReadControllerVue);

        $('[data-toggle="tooltip"]').tooltip();

        // datalayer
        Datalayer.push(Json.datalayer);

        // 初始化輪播
        $(window).on('load', () => {
            $('.splide').show();
            $('.smallPicList').show();
            $('.picBox .spinner-border').hide();
            // 大圖輪播
            const bigPic = new Splide('#bigPic', {
                type: 'fade',
                pagination: false,
                arrows: false,
            });

            // 小圖輪播
            const smallPic = new Splide('#smallPic', {
                pagination: false,
                arrows: false,
                isNavigation: true,
                focus: 0,
                perPage: 4,
                gap: 10,
                breakpoints: {},
            }).mount();

            bigPic.sync(smallPic).mount();
        });

        $(window).on('scroll', (event: Event) => {
            const height = $(window).height();
            if ($(event.currentTarget)
                .scrollTop() >= height) {
                $('.stickyBar')
                    .show();
            } else {
                $('.stickyBar')
                    .hide();
            }
        });

        // Modal
        $('.nologin').on('click', () => {
            $('#MsgModal').modal({
                backdrop: 'static',
                keyboard: false,
            });
        });
    }
})();
